import React from "react";
import { Box, Flex, Text, VStack } from "@chakra-ui/react";
import SceneObjectDetails from "./SceneObjectDetails";
import ModelList from "./ModelList";

const basePanels = [
  {
    label: "Models",
    value: "models",
    component: ModelList,
    isOpen: true,
  },
  {
    label: "Object Details",
    value: "details",
    component: SceneObjectDetails,
    isOpen: false,
  },
];

function ObjectPanel({ panels, componentProps = {}, headerExtra }) {
  const currentPanels = panels || basePanels;

  return (
    <Flex direction="column" h="100%" w="100%" bg="#141414" color="white" overflowX="hidden">
      <Box flex="1" overflowY="auto" overflowX="hidden" px={3} pb={{ base: "120px", md: 3 }}>
        <VStack align="stretch" spacing={0}>
          {currentPanels.map(({ label, value, component, hideTitle, props: panelProps }, index) => {
            // Merge component-level props with panel-specific props
            const mergedProps = { ...componentProps, ...panelProps };
            if (hideTitle) return React.createElement(component, mergedProps);
            return (
              <Box key={value}>
                <Box
                  px={3}
                  py={4}
                  borderBottom="2px solid"
                  borderColor="gray.600"
                  bg="gray.800"
                  position="sticky"
                  top={0}
                  zIndex={9999}
                  mx={-3}
                  width="calc(100% + 24px)"
                >
                  <Text fontWeight="bold" fontSize="lg" textTransform="uppercase" letterSpacing="wide">{label}</Text>
                  {/* Extra content frozen beneath the first panel's title (e.g. mobile Move Object toggle) */}
                  {index === 0 && headerExtra}
                </Box>
                <Box py={2}>
                  {React.createElement(component, mergedProps)}
                </Box>
              </Box>
            );
          })}
        </VStack>
      </Box>
    </Flex>
  );
}

export default ObjectPanel;
